module.exports = __webpack_public_path__ + "img/mw.baf490bf.svg";